/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type FundFamilyEventTypeEnum = typeof FundFamilyEventTypeEnum[keyof typeof FundFamilyEventTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundFamilyEventTypeEnum = {
  allocation_rule_change: 'allocation_rule_change',
  configuration: 'configuration',
  adjustment: 'adjustment',
  cancel_correct: 'cancel_correct',
  capital_activity: 'capital_activity',
  charge_fee: 'charge_fee',
  create_fee_offsettable_expense: 'create_fee_offsettable_expense',
  closing: 'closing',
  credit_facility: 'credit_facility',
  end_of_period_report: 'end_of_period_report',
  investor_transfer: 'investor_transfer',
  capital_call_reallocation: 'capital_call_reallocation',
  portfolio_transaction_posting: 'portfolio_transaction_posting',
} as const;
